import { render, staticRenderFns } from "./CrossReferenceTab.vue?vue&type=template&id=25c16446"
import script from "./CrossReferenceTab.ts?vue&type=script&lang=ts&external"
export * from "./CrossReferenceTab.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports